// tslint:disable: no-invalid-template-strings
import { ActionType, createAction } from 'typesafe-actions';
import { IListObjectStore } from '../../_common/type';
import {
    EORB4RecordCode,
    TORB4BackendRecord,
	TORB4HistoryFilters,
} from './@types';

enum EORB4Constants {
    FEATURE = '@orb-4',
    // API = '/marpol-oil-record-book2',
    API = '/api/marpol/all',
}
enum EORB4Actions {
    HISTORY_LOAD = '@orb-4/:history-load',

    HISTORY_SET = '@orb-4/${history}/set',

    GOTO_DASHBOARD = '@orb4/-->dashboard',
    GOTO_OPERATION_DASHBOARD = '@orb4/-->operation-dashboard',
    GOTO_SELECTED_OPERATION = '@orb4/-->selected-operation',
    GOTO_HISTORY = '@orb4/-->history',

    SET_FILTER = '@orb4/:set-filter',
}

const orb4Actions = {
    commands: {
        historyLoad: createAction(
            EORB4Actions.HISTORY_LOAD,
            (providedFilters: TORB4HistoryFilters) => ({ providedFilters })
        )(),
    },
    document: {
        historySet: createAction(
            EORB4Actions.HISTORY_SET,
            (history: IListObjectStore<TORB4BackendRecord>) => ({ history })
        )(),
        setFilter: createAction(EORB4Actions.SET_FILTER, (filter: any) => ({
            filter,
        }))(),
    },
    routes: {
        gotoDashboard: createAction(EORB4Actions.GOTO_DASHBOARD)(),
        gotoOperationDashboard: createAction(
            EORB4Actions.GOTO_OPERATION_DASHBOARD
        )(),
        gotoSelectedOperation: createAction(
            EORB4Actions.GOTO_SELECTED_OPERATION,
            (operationCode: EORB4RecordCode) => ({ operationCode })
        )(),
        gotoHistory: createAction(EORB4Actions.GOTO_HISTORY)(),
    },
    events: {},
};

export type TORB4Actions = ActionType<typeof orb4Actions>;
export default orb4Actions;
export { EORB4Constants, EORB4Actions };
